var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isConsumerNameFormatValid, isIso3166Alpha2 } from "@payair/e-com-common-sdk/core/Validators";
import { isAssignedCountryCallingCode } from "@payair/e-com-common-sdk/phone/CountryCallingCodes";
import { getConsumerNameLength } from "./ConsumerValidationProfiles";
var EMAIL_MAX_LENGTH = 255;
var NATIONAL_IDENTIFIER_MAX_LENGTH = 20;
var PHONE_COUNTRY_CODE_MAX_LENGTH = 3;
var PHONE_NUMBER_MIN_LENGTH = 4;
var PHONE_NUMBER_MAX_LENGTH = 14;
var E164_MAX_LENGTH = 15;
var EMAIL_FORMAT = /^([a-zA-Z0-9]+(?:[.+_-]+[a-zA-Z0-9]+)*)@([a-zA-Z0-9]+(?:[.-]+[a-zA-Z0-9]+)*){1,253}\.([a-zA-Z0-9]+(?:\.+[a-zA-Z0-9]+)*)$/;
var DUPLICATED_EMAIL_SPECIAL_CHARACTERS = /([.+_-]){2}/;
var DIGITS_ONLY = /^\d+$/;
var normalizePhonePart = function (value) { return value.trim().replace(/[\s()+-]/g, ""); };
export var normalizePhoneNumber = function (phoneNumber) {
    var countryCode = normalizePhonePart(phoneNumber.countryCode || "");
    if (countryCode.indexOf("00") === 0) {
        countryCode = countryCode.slice(2);
    }
    return {
        countryCode: countryCode,
        phoneNumber: normalizePhonePart(phoneNumber.phoneNumber || ""),
    };
};
var isEmailFormatValid = function (emailAddress) {
    return EMAIL_FORMAT.test(emailAddress) && !DUPLICATED_EMAIL_SPECIAL_CHARACTERS.test(emailAddress);
};
export var isConsumerCountryCodeValid = function (countryCode) {
    return typeof countryCode === "string" &&
        countryCode.length === 2 &&
        countryCode === countryCode.trim().toUpperCase() &&
        isIso3166Alpha2(countryCode);
};
var addError = function (errors, field, code, parameters) {
    if (parameters === void 0) { parameters = {}; }
    errors.push(__assign({ field: field, code: code }, parameters));
};
var ConsumerInfoValidator = /** @class */ (function () {
    function ConsumerInfoValidator() {
    }
    ConsumerInfoValidator.validate = function (value, options) {
        var errors = [];
        if (!value.firstName) {
            addError(errors, "firstName", "REQUIRED");
        }
        else if (getConsumerNameLength(value.firstName) < options.firstNameLength.min ||
            getConsumerNameLength(value.firstName) > options.firstNameLength.max) {
            addError(errors, "firstName", "INVALID_LENGTH", __assign(__assign({}, (options.firstNameLength.min > 1 ? { minLength: options.firstNameLength.min } : {})), { maxLength: options.firstNameLength.max }));
        }
        else if (!isConsumerNameFormatValid(value.firstName)) {
            addError(errors, "firstName", "INVALID_FORMAT");
        }
        if (!value.lastName) {
            addError(errors, "lastName", "REQUIRED");
        }
        else if (getConsumerNameLength(value.lastName) < options.lastNameLength.min ||
            getConsumerNameLength(value.lastName) > options.lastNameLength.max) {
            addError(errors, "lastName", "INVALID_LENGTH", {
                minLength: options.lastNameLength.min,
                maxLength: options.lastNameLength.max,
            });
        }
        else if (!isConsumerNameFormatValid(value.lastName)) {
            addError(errors, "lastName", "INVALID_FORMAT");
        }
        if (!value.emailAddress) {
            addError(errors, "emailAddress", "REQUIRED");
        }
        else if (value.emailAddress.length > EMAIL_MAX_LENGTH) {
            addError(errors, "emailAddress", "INVALID_LENGTH", { maxLength: EMAIL_MAX_LENGTH });
        }
        else if (!isEmailFormatValid(value.emailAddress)) {
            addError(errors, "emailAddress", "INVALID_FORMAT");
        }
        var phoneCountryCode = value.mobileNumber.countryCode;
        var phoneNumber = value.mobileNumber.phoneNumber;
        if (!phoneCountryCode || !phoneNumber) {
            addError(errors, "mobileNumber", "REQUIRED");
        }
        else if (!DIGITS_ONLY.test(phoneCountryCode) ||
            phoneCountryCode.length > PHONE_COUNTRY_CODE_MAX_LENGTH ||
            !isAssignedCountryCallingCode(phoneCountryCode) ||
            !DIGITS_ONLY.test(phoneNumber)) {
            addError(errors, "mobileNumber", "INVALID_FORMAT");
        }
        else if (phoneNumber.length < PHONE_NUMBER_MIN_LENGTH ||
            phoneNumber.length > PHONE_NUMBER_MAX_LENGTH ||
            phoneCountryCode.length + phoneNumber.length > E164_MAX_LENGTH) {
            addError(errors, "mobileNumber", "INVALID_LENGTH");
        }
        if (!value.countryCode) {
            if (options.countryRequired) {
                addError(errors, "countryCode", "REQUIRED");
            }
        }
        else if (!isConsumerCountryCodeValid(value.countryCode)) {
            addError(errors, "countryCode", "INVALID_FORMAT");
        }
        if (value.nationalIdentifier && value.nationalIdentifier.length > NATIONAL_IDENTIFIER_MAX_LENGTH) {
            addError(errors, "nationalIdentifier", "INVALID_LENGTH", { maxLength: NATIONAL_IDENTIFIER_MAX_LENGTH });
        }
        return errors;
    };
    return ConsumerInfoValidator;
}());
export { ConsumerInfoValidator };
